import(/* webpackMode: "eager" */ "/home/runner/work/AlUmmahNow/AlUmmahNow/node_modules/next/dist/client/app-dir/link.js");
